import {PAEnvironment} from "../PA.Core/PAEnvironment";
import axios from 'axios';
import {
    ISimulationService, ISimulationServiceAdhocCalcResponse,
    ISimulationServiceCalculateOptions,
    ISimulationServiceRequest,
    ISimulationServiceResponse

} from "./SimulationServices.IF";

import {IScenarioServiceRequest, ISimulatorServiceRequest} from "../PA.BusinessModeler.Services/PA.Simulator.Services.IF"
import { DateUtils } from "../PA.Core/Basic/Dates";


export class SimulationService
    implements
        ISimulationService
{

    CalculatePromotionSimulation(wbSimulationId: number, options?: ISimulationServiceCalculateOptions): Promise<ISimulationServiceResponse> {
        const aCalculateRequest: ISimulatorServiceRequest = {
            RequestType: "CalculateAndSave",
            RequestOptions: options || {},
            wbSimulationId: wbSimulationId
        };

        return this.makeRequest(aCalculateRequest)
    }



    GetSimulationStatus(wbSimulationId: number,options?: ISimulationServiceCalculateOptions):Promise<ISimulationServiceResponse> {

        const aCalculateRequest: ISimulatorServiceRequest = {
            RequestType: "GetStatus",
            RequestOptions: options || {},
            wbSimulationId: wbSimulationId
        };
        return this.makeRequest(aCalculateRequest)
    }

    CalculateScenarioPlan(wbScnPlanId: number): Promise<ISimulationServiceResponse> {
        const aCalculateRequest: IScenarioServiceRequest = {
            RequestType: "CalculateAndSave",
            wbScnPlanId: wbScnPlanId
        };
        return this.makeScenarioRequest(aCalculateRequest)
    }

    GetScenarioPlanStatus(wbScnPlanId: number): Promise<ISimulationServiceResponse> {
        const aCalculateRequest: IScenarioServiceRequest = {
            RequestType: "GetStatus",
            wbScnPlanId: wbScnPlanId
        };
        return this.makeScenarioRequest(aCalculateRequest)
    }

    CalculateAdhocScenarioPlan(wbScnPlanId: number,
                               wbSimulationIds: number[],
                               wbCustIds: number[],
                               wbPrdGrpIds: number[],
                               startDate: Date,
                               endDate: Date): Promise<ISimulationServiceAdhocCalcResponse>
    {
        const aCalculateRequest: IScenarioServiceRequest = {
            RequestType: "CalculateAdHoc",
            wbScnPlanId: wbScnPlanId,
            wbSimulationIds: wbSimulationIds,
            wbCustIds: wbCustIds,
            wbPrdGrpIds: wbPrdGrpIds,
            startDt: DateUtils.convertToSAPBW(startDate),
            endDt: DateUtils.convertToSAPBW(endDate),
        };
        return this.makeScenarioRequest(aCalculateRequest)
    }




    private makeRequest(aRequest: ISimulationServiceRequest): Promise<ISimulationServiceResponse> {
        return new Promise<ISimulationServiceResponse>((resolve, error) => {
            let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base), "/");
            if (sEndPoint.endsWith('/')) {
                sEndPoint += 'simulatorService';
            } else {
                sEndPoint += '/simulatorService';
            }

            axios.post(sEndPoint, {data: {request: aRequest}})
                .then((resp) => {
                    const responseData = resp.data;
                    resolve(responseData);
                })
                .catch((err) => {
                    error(err);
                })
        })
    }

    private async makeScenarioRequest(aRequest: IScenarioServiceRequest): Promise<ISimulationServiceResponse> {
        let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base), '/')
        if (sEndPoint.endsWith('/')) {
            sEndPoint += 'scenarioService'
        } else {
            sEndPoint += '/scenarioService'
        }

        try {
            const resp = await axios.post(sEndPoint, { data: { request: aRequest } })
            return resp.data
        } catch (e) {
            throw new Error(e)
        }
    }
}
